export enum TipoQr {
  IMPRESO = '01',
  DIGITAL = '02',
}
